import { PageSection } from '@/types/page/props';
import originals from './pages/originals';

export const originalsSection: PageSection = {
  label: 'betblex_originals_side',
  icon: 'fa-solid fa-fire',
  pages: originals,
};
